import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEst = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_9162_14652",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 17,
		height: 17,
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 8.5,
			cy: 8.5,
			r: 8.5,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_9162_14652)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M-5 0H21V17H-5V0Z",
				fill: "#111111"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M-5 0H21V5.66665H-5V0Z",
				fill: "#368FD8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M-5 11.3333H21V17H-5V11.3333Z",
				fill: "white"
			})
		]
	})]
});
export default SvgEst;
